export default "__VITE_ASSET__BdHSa4PL__"